import { PropsWithChildren } from 'react'
import './StatusCell.scss'
import { WorkflowOrderStepStatus } from '@ail/orders-api'
import { ContractState } from '@ail/contracts-api'

interface StatusCellProps extends PropsWithChildren {
  status: WorkflowOrderStepStatus | ContractState
  disabled?: boolean
  onClick?: () => void
}

export function StatusCell(props: StatusCellProps) {
  return (
    <div
      style={{ cursor: props.onClick ? 'pointer' : 'default' }}
      className={`grid-status-cell ${props.status} ${props.disabled ? 'disabled' : ''}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  )
}
